var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","type":"danger","loading":_vm.loading},on:{"click":function($event){return _vm.start(_vm.ids)}}},[_vm._v(_vm._s(_vm.$t('button.delete')))])
}
var staticRenderFns = []

export { render, staticRenderFns }